export const orderStatusOptionsStatic = [
    {'value': 'Shipped', 'label': 'Shipped'},
    {'value': 'In Process', 'label': 'In Process'},
    {'value': 'In Process - Backorder', 'label': 'In Process - Backorder'},
    {'value': 'In Process - Scheduled Order', 'label': 'In Process - Scheduled Order'},
    {'value': 'On Hold', 'label': 'On Hold'},
    {'value': 'Order Cancelled - Authorization Not Approved', 'label': 'Order Cancelled - Authorization Not Approved'},
    {'value': 'Order Cancelled - Canceled per Doc Policy', 'label': 'Order Cancelled - Canceled per Doc Policy'},
    {'value': 'Order Cancelled - Eligibility Issue', 'label': 'Order Cancelled - Eligibility Issue'},
    {
        'value': 'Order Cancelled - Insufficient Medical Documents',
        'label': 'Order Cancelled - Insufficient Medical Documents'
    },
    {
        'value': 'Order Cancelled - Insufficient Patient Documents',
        'label': 'Order Cancelled - Insufficient Patient Documents'
    },
    {'value': 'Order Cancelled - No Response from Sales Rep', 'label': 'Order Cancelled - No Response from Sales Rep'},
    {'value': 'Order Cancelled - Non-Covered Items', 'label': 'Order Cancelled - Non-Covered Items'},
    {'value': 'Order Cancelled - Non-Participating Payer', 'label': 'Order Cancelled - Non-Participating Payer'},
    {
        'value': 'Order Cancelled - Order Cancelled Before Shipment',
        'label': 'Order Cancelled - Order Cancelled Before Shipment'
    },
    {'value': 'Order Cancelled - Order Created in Error', 'label': 'Order Cancelled - Order Created in Error'},
    {'value': 'Order Cancelled - Order Created Previously', 'label': 'Order Cancelled - Order Created Previously'},
    {'value': 'Order Cancelled - Outsourced Order', 'label': 'Order Cancelled - Outsourced Order'},
    {'value': 'Order Cancelled - ParachuteHealth', 'label': 'Order Cancelled - ParachuteHealth'},
    {'value': 'Order Cancelled - Patient - OOP Cost', 'label': 'Order Cancelled - Patient - OOP Cost'},
    {'value': 'Order Cancelled - Patient Cancelled Order', 'label': 'Order Cancelled - Patient Cancelled Order'},
    {'value': 'Order Cancelled - Patient Deceased', 'label': 'Order Cancelled - Patient Deceased'},
    {'value': 'Order Cancelled - Patient Never Responded', 'label': 'Order Cancelled - Patient Never Responded'},
    {'value': 'Order Cancelled - Referral Cancelled Order', 'label': 'Order Cancelled - Referral Cancelled Order'},
    {
        'value': 'Order Cancelled - Reorder too soon (Order Exceeds 14 Days)',
        'label': 'Order Cancelled - Reorder too soon (Order Exceeds 14 Days)'
    },
    {'value': 'Order Cancelled - RRB Created in Error', 'label': 'Order Cancelled - RRB Created in Error'},
    {'value': 'Order Cancelled - Wound Care Rekey', 'label': 'Order Cancelled - Wound Care Rekey'},
    {'value': 'Pending  - Authorization Needed', 'label': 'Pending  - Authorization Needed'},
    {'value': 'Pending  - Documentation Needed', 'label': 'Pending  - Documentation Needed'},
    {'value': 'Pending  - Information Needed', 'label': 'Pending  - Information Needed'},
    {'value': 'Pending - Authorization', 'label': 'Pending - Authorization'},
    {'value': 'Pending - Authorization Needed', 'label': 'Pending - Authorization Needed'},
    {'value': 'Pending - Documentation Needed', 'label': 'Pending - Documentation Needed'},
    {'value': 'Pending - Information Needed', 'label': 'Pending - Information Neede'}
];

export const equipmentType = [
    {'value': 'CPAP', 'label': 'CPAP'},
    {'value': 'Oxygen', 'label': 'Oxygen'},
    {'value': 'Walkers', 'label': 'Walkers'},
    {'value': 'Beds', 'label': 'Beds'}
]

export const maskType = [
    {'value': 'CPAP MASK NASAL MIRAGE FX', 'label': 'CPAP MASK NASAL MIRAGE FX'},
    {'value': 'CPAP MASK FF AMARA VIEW SMALL, HG', 'label': 'CPAP MASK FF AMARA VIEW SMALL, HG'},
    {'value': 'CPAP MASK FULL FACE AIRFIT F20 LARGE', 'label': 'CPAP MASK FULL FACE AIRFIT F20 LARGE'}
]

export const voidReason = [
    {'value': 'Authorization Denial', 'label': 'Authorization Denial'},
    {'value': "Can''t Afford Copay", 'label': "Can''t Afford Copay"},
    {'value': 'Does Not Want Equip', 'label': 'Does Not Want Equip'},
    {'value': 'No Response from Patient', 'label': 'No Response from Patient'},
    {'value': 'Not Eligible', 'label': 'Not Eligible'},
    {'value': 'Not in network with Insurance', 'label': 'Not in network with Insurance'},
    {'value': 'Not in service area', 'label': 'Not in service area'},
    {'value': 'Patient Cancelled Order', 'label': 'Patient Cancelled Order'},
    {'value': 'Patient Deceased', 'label': 'Patient Deceased'},
    {'value': 'Patient Refused Copay', 'label': 'Patient Refused Copay'},
    {'value': 'Referral Cancelled Order', 'label': 'Referral Cancelled Order'},
    {'value': 'Unable to Contact Patient for Copay', 'label': 'Unable to Contact Patient for Copay'},
    {'value': 'Unprocessed Order - Incomplete Docs', 'label': 'Unprocessed Order - Incomplete Docs'},
];
export const optionsNoDataParams = [{
    'value': "noData",
    'label': "Please enter at least 4 characters"
}];

export const optionsScreenerFollowUpStatus = [
    {'value': "New Result", 'label': "New Result"},
    {'value': "Discussed with Provider", 'label': "Discussed with Provider"},
    {'value': "Pending Provider Review with Patient", 'label': "Pending Provider Review with Patient"},
    {'value': "Pending Sleep Study", 'label': "Pending Sleep Study"},
    {'value': "Closed: Patient Successfully on Therapy", 'label': "Closed: Patient Successfully on Therapy"},
    {'value': "Closed: Therapy Not Needed", 'label': "Closed: Therapy Not Needed"},
    {'value': "Closed: Unsuccessful - Other", 'label': "Closed: Unsuccessful - Other"},
];

